export default {
    // 中
    zhCN: {
        query_time: '查询时间',
        number_of_closedCases: '关单数量',
        percentage_of_closedCases: '关单率',
        SAP: 'SAP',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        total_number_of_cases: '案件总数',
        statistical_days: '统计天数',
        organization_name_full: '组织名称(全量查询)',
        num_of_received_documents_r: '收到单据数量（责任方）',
        num_of_received_documents_nr: '收到单据数量（非责任方）',
        num_of_forwarded_documents_r: '转发单据数量（责任方）',
        num_of_forwarded_documents_nr: '转发单据数量（非责任方）',
        inquire_quantity_documents: '问询单据数量',
    },
    // 英
    enUS: {
        query_time: 'Query time',
        number_of_closedCases: 'Number of closedCases',
        percentage_of_closedCases: 'Percentage of closedCases',
        SAP: 'SAP',
        organization_code: 'Organization CODE',
        organization_name: 'Organization Name',
        country: 'Country',
        total_number_of_cases: 'Total Number Of Cases',
        statistical_days: 'Statistical Days',
        organization_name_full: 'Organization Name(full search)',
        num_of_received_documents_r: 'Number of received documents (responsible party)',
        num_of_received_documents_nr: 'Number of received documents (non-responsible party)',
        num_of_forwarded_documents_r: 'Number of forwarded documents (responsible party)',
        num_of_forwarded_documents_nr: 'Number of forwarded documents (non-responsible party)',
        inquire_quantity_documents: 'Number of inquiry documents',
    },
    // 德
    deDE: {
        query_time: 'Abfragezeit',
        number_of_closedCases: 'Anzahl abgeschlossener Fälle',
        percentage_of_closedCases: 'Prozentsatz der abgeschlossenen Fälle',
        SAP: 'SAP',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        total_number_of_cases: 'Gesamtzahl der Fälle',
        organization_name_full: 'Organisationsname(full search)',
        num_of_received_documents_r: 'Anzahl empfangener Dokumente (verantwortliche Partei)',
        num_of_received_documents_nr: 'Anzahl empfangener Dokumente (nicht verantwortliche Partei)',
        num_of_forwarded_documents_r: 'Anzahl weitergeleiteter Dokumente (verantwortliche Partei)',
        num_of_forwarded_documents_nr:
            'Anzahl weitergeleiteter Dokumente (nicht verantwortliche Partei)',
        inquire_quantity_documents: 'Anzahl der Anfrage-Dokumente',
    },
    // 法
    frFR: {
        query_time: 'Temps de requête',
        number_of_closedCases: 'Nombre de cas fermés',
        percentage_of_closedCases: 'Pourcentage de cas clos',
        SAP: 'SAP',
        organization_code: 'Code de l\'organisme',
        organization_name: 'Nom de l\'institution',
        country: 'Pays',
        total_number_of_cases: 'Nombre total de cas',
        organization_name_full: 'Nom de l\'institution(full search)',
        num_of_received_documents_r: 'Nombre de documents reçus (partie responsable)',
        num_of_received_documents_nr: 'Nombre de documents reçus (partie non responsable)',
        num_of_forwarded_documents_r: 'Nombre de documents transférés (partie responsable)',
        num_of_forwarded_documents_nr: 'Nombre de documents transférés (partie non responsable)',
        inquire_quantity_documents: 'Nombre de documents d\'enquête',
    },
    // 意大利
    itIT: {
        query_time: 'Tempo di Query',
        number_of_closedCases: 'Numero di casi chiusi',
        percentage_of_closedCases: 'Percentuale di casi chiusi',
        SAP: 'SAP',
        organization_code: 'Codice dell\'organizzazione',
        organization_name: 'Nome dell\'organizzazione',
        country: 'Paese',
        total_number_of_cases: 'Numero totale di casi',
        organization_name_full: 'Nome dell\'organizzazione(full search)',
        num_of_received_documents_r: 'Numero di documenti ricevuti (parte responsabile)',
        num_of_received_documents_nr: 'Numero di documenti ricevuti (parte non responsabile)',
        num_of_forwarded_documents_r: 'Numero di documenti inoltrati (parte responsabile)',
        num_of_forwarded_documents_nr: 'Numero di documenti inoltrati (parte non responsabile)',
        inquire_quantity_documents: 'Numero di documenti di richiesta',
    },
    // 荷兰
    nlNL: {
        query_time: 'Query time',
        number_of_closedCases: 'Aantal gesloten zaken',
        percentage_of_closedCases: 'Percentage gesloten zaken',
        SAP: 'SAP',
        organization_code: 'Organisatiecode',
        organization_name: 'Organisatienaam',
        country: 'Naties',
        total_number_of_cases: 'Totaal aantal gevallen',
        organization_name_full: 'Organisatienaam(full search)',
        num_of_received_documents_r: 'Aantal ontvangen documenten (verantwoordelijke partij)',
        num_of_received_documents_nr: 'Aantal ontvangen documenten (niet-verantwoordelijke partij)',
        num_of_forwarded_documents_r: 'Aantal doorgestuurde documenten (verantwoordelijke partij)',
        num_of_forwarded_documents_nr:
            'Aantal doorgestuurde documenten (niet-verantwoordelijke partij)',
        inquire_quantity_documents: 'Aantal vraagdocumenten',
    },
    // 越南
    viVN: {
        query_time: 'Thời gian truy vấn',
        number_of_closedCases: 'Số lượng case closed',
        percentage_of_closedCases: 'Phần trăm các trường hợp đóng',
        SAP: 'SAP',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        total_number_of_cases: 'Tổng số trường hợp',
        organization_name_full: 'Tên tổ chức(full search)',
        num_of_received_documents_r: 'Số lượng tài liệu nhận được (bên chịu trách nhiệm)',
        num_of_received_documents_nr: 'Số lượng tài liệu nhận được (bên không chịu trách nhiệm)',
        num_of_forwarded_documents_r: 'Số lượng tài liệu chuyển tiếp (bên chịu trách nhiệm)',
        num_of_forwarded_documents_nr: 'Số lượng tài liệu chuyển tiếp (bên không chịu trách nhiệm)',
        inquire_quantity_documents: 'Số lượng tài liệu hỏi thăm',
    },
    // 西班牙
    esES: {
        query_time: 'Consulta de tiempo',
        number_of_closedCases: 'Número de casos cerrados',
        percentage_of_closedCases: 'Porcentaje de casos cerrados',
        SAP: 'SAP',
        organization_code: 'Código de organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        organization_name_full: 'Nombre de la organización(full search)',
        num_of_received_documents_r: 'Cantidad de documentos recibidos (parte responsable)',
        num_of_received_documents_nr: 'Cantidad de documentos recibidos (parte no responsable)',
        num_of_forwarded_documents_r: 'Cantidad de documentos reenviados (parte responsable)',
        num_of_forwarded_documents_nr: 'Cantidad de documentos reenviados (parte no responsable)',
        inquire_quantity_documents: 'Cantidad de documentos de consulta',
    },
    // 葡萄牙
    ptBR: {
        query_time: 'Tempo de consulta',
        number_of_closedCases: 'Número de casos encerrados',
        percentage_of_closedCases: 'Percentagem de casos encerrados',
        SAP: 'SAP',
        organization_code: 'Código de organização',
        organization_name: 'Nome da organização',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        organization_name_full: 'Nome da organização(full search)',
        num_of_received_documents_r: 'Número de documentos recebidos (parte responsável)',
        num_of_received_documents_nr: 'Número de documentos recebidos (parte não responsável)',
        num_of_forwarded_documents_r: 'Número de documentos encaminhados (parte responsável)',
        num_of_forwarded_documents_nr: 'Número de documentos encaminhados (parte não responsável)',
        inquire_quantity_documents: 'Número de documentos de consulta',
    },
    // 波兰
    plPL: {
        query_time: 'Data zapytania',
        number_of_closedCases: 'Liczba zamkniętych spraw',
        percentage_of_closedCases: 'Procent zamkniętych spraw',
        SAP: 'SAP',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        total_number_of_cases: 'Łączna liczba spraw',
        organization_name_full: 'Nazwa organizacji(full search)',
        num_of_received_documents_r: 'Liczba otrzymanych dokumentów (strona odpowiedzialna)',
        num_of_received_documents_nr: 'Liczba otrzymanych dokumentów (strona nieodpowiedzialna)',
        num_of_forwarded_documents_r: 'Liczba przekazanych dokumentów (strona odpowiedzialna)',
        num_of_forwarded_documents_nr: 'Liczba przekazanych dokumentów (strona nieodpowiedzialna)',
        inquire_quantity_documents: 'Liczba dokumentów zapytań',
    },
    // 土耳其
    trTR: {
        query_time: 'Sorgulama zamanı',
        number_of_closedCases: 'Kapatma sayısı',
        percentage_of_closedCases: 'Kapat oranı',
        SAP: 'SAP',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        total_number_of_cases: 'Toplam vaka sayısı',
        organization_name_full: 'Organizasyon adı(full search)',
        num_of_received_documents_r: 'Alınan belge sayısı (sorumlu taraf)',
        num_of_received_documents_nr: 'Alınan belge sayısı (sorumlu olmayan taraf)',
        num_of_forwarded_documents_r: 'Yönlendirilen belge sayısı (sorumlu taraf)',
        num_of_forwarded_documents_nr: 'Yönlendirilen belge sayısı (sorumlu olmayan taraf)',
        inquire_quantity_documents: 'Sorgulanan belge sayısı',
    },
    // 捷克语
    csCZ: {
        query_time: 'Čas dotazu',
        number_of_closedCases: 'Počet uzavřených případů',
        percentage_of_closedCases: 'Procento uzavřených případů',
        SAP: 'SAP',
        organization_code: 'Kód společnosti',
        organization_name: 'Název organizace',
        country: 'Země',
        total_number_of_cases: 'Celkový počet případů',
        statistical_days: 'Statistické dny',
        organization_name_full: 'Název organizace(full search)',
        num_of_received_documents_r: 'Počet přijatých dokumentů (odpovědná strana)',
        num_of_received_documents_nr: 'Počet přijatých dokumentů (neodpovědná strana)',
        num_of_forwarded_documents_r: 'Počet předaných dokumentů (odpovědná strana)',
        num_of_forwarded_documents_nr: 'Počet předaných dokumentů (neodpovědná strana)',
        inquire_quantity_documents: 'Počet dotazovaných dokumentů',
    },
    // 匈牙利语
    huHU: {
        query_time: 'Lekérdezési idő',
        number_of_closedCases: 'Lezárt esetek száma',
        percentage_of_closedCases: 'Lezárt esetek százaléka',
        SAP: 'SAP',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        total_number_of_cases: 'Összes eset száma',
        statistical_days: 'Statisztikai napok',
        organization_name_full: 'Szervezet neve(full search)',
        num_of_received_documents_r: 'Átvett dokumentumok száma (felelős fél)',
        num_of_received_documents_nr: 'Átvett dokumentumok száma (nem felelős fél)',
        num_of_forwarded_documents_r: 'Továbbított dokumentumok száma (felelős fél)',
        num_of_forwarded_documents_nr: 'Továbbított dokumentumok száma (nem felelős fél)',
        inquire_quantity_documents: 'Kérdéses dokumentumok száma',
    },
    // 俄罗斯语
    ruRU: {
        query_time: 'Время запроса',
        number_of_closedCases: 'Количество закрытых дел',
        percentage_of_closedCases: 'Процент закрытых дел',
        SAP: 'SAP',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        total_number_of_cases: 'Общее количество случаев',
        statistical_days: 'Статистические дни',
        organization_name_full: 'Название организации(full search)',
        num_of_received_documents_r: 'Количество полученных документов (ответственная сторона)',
        num_of_received_documents_nr: 'Количество полученных документов (неответственная сторона)',
        num_of_forwarded_documents_r: 'Количество пересланных документов (ответственная сторона)',
        num_of_forwarded_documents_nr:
            'Количество пересланных документов (неответственная сторона)',
        inquire_quantity_documents: 'Количество запросных документов',
    },
    // 沙特阿拉伯
    arSA: {
        query_time: 'وقت الاستعلام',
        number_of_closedCases: 'عدد الطلبات المغلقة',
        percentage_of_closedCases: 'نسبة الطلبات المغلقة',
        SAP: 'SAP',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        total_number_of_cases: 'إجمالي عدد الحالات',
        statistical_days: 'أيام الإحصاء',
        organization_name_full: 'اسم المنظمة (استعلام كامل)',
        num_of_received_documents_r: 'عدد المستندات المستلمة (الطرف المسؤول)',
        num_of_received_documents_nr: 'عدد المستندات المستلمة (الطرف غير المسؤول)',
        num_of_forwarded_documents_r: 'عدد المستندات المحولة (الطرف المسؤول)',
        num_of_forwarded_documents_nr: 'عدد المستندات المحولة (الطرف غير المسؤول)',
        inquire_quantity_documents: 'كمية المستندات المستعلمة',
    },
    // 保加利亚
    bgBG: {
        query_time: 'Време на заявката',
        number_of_closedCases: 'Брой затворени случаи',
        percentage_of_closedCases: 'Процент затворени случаи',
        SAP: 'SAP',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        total_number_of_cases: 'Общ брой случаи',
        statistical_days: 'Статистически дни',
        organization_name_full: 'Име на организацията (пълно запитване)',
        num_of_received_documents_r: 'Брой получени документи (отговорна страна)',
        num_of_received_documents_nr: 'Брой получени документи (неотговорна страна)',
        num_of_forwarded_documents_r: 'Брой препратени документи (отговорна страна)',
        num_of_forwarded_documents_nr: 'Брой препратени документи (неотговорна страна)',
        inquire_quantity_documents: 'Брой документи за запитване',
    },
    // 丹麦语
    daDK: {
        query_time: 'Forespørgselstidspunkt',
        number_of_closedCases: 'Antal lukkede sager',
        percentage_of_closedCases: 'Procentdel lukkede sager',
        SAP: 'SAP',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        total_number_of_cases: 'Samlet antal sager',
        statistical_days: 'Statistikdage',
        organization_name_full: 'Organisationsnavn (fuld forespørgsel)',
        num_of_received_documents_r: 'Antal modtagne dokumenter (ansvarlig part)',
        num_of_received_documents_nr: 'Antal modtagne dokumenter (ikke-ansvarlig part)',
        num_of_forwarded_documents_r: 'Antal videresendte dokumenter (ansvarlig part)',
        num_of_forwarded_documents_nr: 'Antal videresendte dokumenter (ikke-ansvarlig part)',
        inquire_quantity_documents: 'Antal forespurgte dokumenter',
    },
    // 芬兰语
    fiFI: {
        query_time: 'Kyselyn aika',
        number_of_closedCases: 'Suljettujen tapausten määrä',
        percentage_of_closedCases: 'Suljettujen tapausten prosentti',
        SAP: 'SAP',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        total_number_of_cases: 'Tapauksien kokonaismäärä',
        statistical_days: 'Tilastopäivät',
        organization_name_full: 'Organisaation nimi (täydellinen kysely)',
        num_of_received_documents_r: 'Vastaanotettujen asiakirjojen määrä (vastuullinen osapuoli)',
        num_of_received_documents_nr:
            'Vastaanotettujen asiakirjojen määrä (ei-vastuullinen osapuoli)',
        num_of_forwarded_documents_r:
            'Edelleenlähetettyjen asiakirjojen määrä (vastuullinen osapuoli)',
        num_of_forwarded_documents_nr:
            'Edelleenlähetettyjen asiakirjojen määrä (ei-vastuullinen osapuoli)',
        inquire_quantity_documents: 'Kysyttyjen asiakirjojen määrä',
    },
    // 繁体中文台湾
    zhTW: {
        query_time: '查詢時間',
        number_of_closedCases: '關單數量',
        percentage_of_closedCases: '關單率',
        SAP: 'SAP',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        total_number_of_cases: '案件總數',
        statistical_days: '統計天數',
        organization_name_full: '組織名稱(全量查詢)',
        num_of_received_documents_r: '收到單據數量（責任方）',
        num_of_received_documents_nr: '收到單據數量（非責任方）',
        num_of_forwarded_documents_r: '轉發單據數量（責任方）',
        num_of_forwarded_documents_nr: '轉發單據數量（非責任方）',
        inquire_quantity_documents: '問詢單據數量',
    },
    // 克罗地亚
    hrHR: {
        query_time: 'Vrijeme upita',
        number_of_closedCases: 'Broj zatvorenih slučajeva',
        percentage_of_closedCases: 'Postotak zatvorenih slučajeva',
        SAP: 'SAP',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        total_number_of_cases: 'Ukupan broj slučajeva',
        statistical_days: 'Dani statistike',
        organization_name_full: 'Naziv organizacije (potpuno pretraživanje)',
        num_of_received_documents_r: 'Broj primljenih dokumenata (odgovorna strana)',
        num_of_received_documents_nr: 'Broj primljenih dokumenata (neodgovorna strana)',
        num_of_forwarded_documents_r: 'Broj prosljeđenih dokumenata (odgovorna strana)',
        num_of_forwarded_documents_nr: 'Broj prosljeđenih dokumenata (neodgovorna strana)',
        inquire_quantity_documents: 'Broj upitanih dokumenata',
    },
    // 拉脱维亚
    lvLV: {
        query_time: 'Vaicājuma laiks',
        number_of_closedCases: 'Slēgto lietu skaits',
        percentage_of_closedCases: 'Slēgto lietu procents',
        SAP: 'SAP',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        total_number_of_cases: 'Gadījumu kopējais skaits',
        statistical_days: 'Statistikas dienas',
        organization_name_full: 'Organizācijas nosaukums (pilns vaicājums)',
        num_of_received_documents_r: 'Saņemto dokumentu skaits (atbildīgā puse)',
        num_of_received_documents_nr: 'Saņemto dokumentu skaits (neatbildīgā puse)',
        num_of_forwarded_documents_r: 'Pārsūtīto dokumentu skaits (atbildīgā puse)',
        num_of_forwarded_documents_nr: 'Pārsūtīto dokumentu skaits (neatbildīgā puse)',
        inquire_quantity_documents: 'Vaicāto dokumentu skaits',
    },
    // 立陶宛
    ltLT: {
        query_time: 'Užklausos laikas',
        number_of_closedCases: 'Uždarytų bylų skaičius',
        percentage_of_closedCases: 'Uždarytų bylų procentas',
        SAP: 'SAP',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        total_number_of_cases: 'Bylų bendras skaičius',
        statistical_days: 'Statistikos dienos',
        organization_name_full: 'Organizacijos pavadinimas (visapusiška užklausa)',
        num_of_received_documents_r: 'Gautų dokumentų skaičius (atsakingoji pusė)',
        num_of_received_documents_nr: 'Gautų dokumentų skaičius (neatsakingoji pusė)',
        num_of_forwarded_documents_r: 'Persiųstų dokumentų skaičius (atsakingoji pusė)',
        num_of_forwarded_documents_nr: 'Persiųstų dokumentų skaičius (neatsakingoji pusė)',
        inquire_quantity_documents: 'Užklaustų dokumentų skaičius',
    },
    // 罗马尼亚
    roRO: {
        query_time: 'Timpul interogării',
        number_of_closedCases: 'Numărul de cazuri închise',
        percentage_of_closedCases: 'Procentul de cazuri închise',
        SAP: 'SAP',
        organization_code: 'Cod organizație',
        organization_name: 'Numele organizației',
        country: 'Țară',
        total_number_of_cases: 'Numărul total de cazuri',
        statistical_days: 'Zile statistice',
        organization_name_full: 'Numele organizației (interogare completă)',
        num_of_received_documents_r: 'Numărul de documente primite (partea responsabilă)',
        num_of_received_documents_nr: 'Numărul de documente primite (partea ne-responsabilă)',
        num_of_forwarded_documents_r: 'Numărul de documente transmise (partea responsabilă)',
        num_of_forwarded_documents_nr: 'Numărul de documente transmise (partea ne-responsabilă)',
        inquire_quantity_documents: 'Numărul de documente întrebate',
    },
    // 挪威博克马尔
    nbNO: {
        query_time: 'Spørringstidspunkt',
        number_of_closedCases: 'Antall lukkede saker',
        percentage_of_closedCases: 'Prosentandel lukkede saker',
        SAP: 'SAP',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        total_number_of_cases: 'Totalt antall saker',
        statistical_days: 'Statistikkdager',
        organization_name_full: 'Organisasjonsnavn (full spørring)',
        num_of_received_documents_r: 'Antall mottatte dokumenter (ansvarlig part)',
        num_of_received_documents_nr: 'Antall mottatte dokumenter (ikke-ansvarlig part)',
        num_of_forwarded_documents_r: 'Antall videresendte dokumenter (ansvarlig part)',
        num_of_forwarded_documents_nr: 'Antall videresendte dokumenter (ikke-ansvarlig part)',
        inquire_quantity_documents: 'Antall spørredokumenter',
    },
    // 葡萄牙语巴西
    ptBX: {
        query_time: 'Tempo de consulta',
        number_of_closedCases: 'Quantidade de encerramentos',
        percentage_of_closedCases: 'Taxa de encerramento',
        SAP: 'SAP',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        statistical_days: 'Dias estatísticos',
        organization_name_full: 'Nome da organização (consulta completa)',
        num_of_received_documents_r: 'Quantidade de documentos recebidos (parte responsável)',
        num_of_received_documents_nr: 'Quantidade de documentos recebidos (parte não responsável)',
        num_of_forwarded_documents_r: 'Quantidade de documentos encaminhados (parte responsável)',
        num_of_forwarded_documents_nr:
            'Quantidade de documentos encaminhados (parte não responsável)',
        inquire_quantity_documents: 'Quantidade de documentos consultados',
    },
    // 瑞典语
    svSE: {
        query_time: 'Frågetid',
        number_of_closedCases: 'Antal stängda ärenden',
        percentage_of_closedCases: 'Andel stängda ärenden',
        SAP: 'SAP',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        total_number_of_cases: 'Totalt antal ärenden',
        statistical_days: 'Statistikdagar',
        organization_name_full: 'Organisationsnamn (fullständig fråga)',
        num_of_received_documents_r: 'Antal mottagna dokument (ansvarig part)',
        num_of_received_documents_nr: 'Antal mottagna dokument (icke ansvarig part)',
        num_of_forwarded_documents_r: 'Antal vidarebefordrade dokument (ansvarig part)',
        num_of_forwarded_documents_nr: 'Antal vidarebefordrade dokument (icke ansvarig part)',
        inquire_quantity_documents: 'Antal efterfrågade dokument',
    },
    // 斯洛伐克
    skSK: {
        query_time: 'Čas dopytu',
        number_of_closedCases: 'Počet uzatvorených prípadov',
        percentage_of_closedCases: 'Percento uzatvorených prípadov',
        SAP: 'SAP',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        total_number_of_cases: 'Celkový počet prípadov',
        statistical_days: 'Štatistické dni',
        organization_name_full: 'Názov organizácie (úplný dopyt)',
        num_of_received_documents_r: 'Počet prijatých dokumentov (zodpovedná strana)',
        num_of_received_documents_nr: 'Počet prijatých dokumentov (nezodpovedná strana)',
        num_of_forwarded_documents_r: 'Počet postúpených dokumentov (zodpovedná strana)',
        num_of_forwarded_documents_nr: 'Počet postúpených dokumentov (nezodpovedná strana)',
        inquire_quantity_documents: 'Počet vyžiadaných dokumentov',
    },
    // 斯洛文尼亚
    slSI: {
        query_time: 'Čas poizvedbe',
        number_of_closedCases: 'Število zaprtih primerov',
        percentage_of_closedCases: 'Odstotek zaprtih primerov',
        SAP: 'SAP',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        total_number_of_cases: 'Skupno število primerov',
        statistical_days: 'Statistični dnevi',
        organization_name_full: 'Ime organizacije (polna poizvedba)',
        num_of_received_documents_r: 'Število prejetih dokumentov (odgovorna stranka)',
        num_of_received_documents_nr: 'Število prejetih dokumentov (neodgovorna stranka)',
        num_of_forwarded_documents_r: 'Število posredovanih dokumentov (odgovorna stranka)',
        num_of_forwarded_documents_nr: 'Število posredovanih dokumentov (neodgovorna stranka)',
        inquire_quantity_documents: 'Število poizvedenih dokumentov',
    },
    // 泰语
    thTH: {
        query_time: 'เวลาค้นหา',
        number_of_closedCases: 'จำนวนการปิดเคส',
        percentage_of_closedCases: 'อัตราการปิดเคส',
        SAP: 'SAP',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        total_number_of_cases: 'จำนวนเคสทั้งหมด',
        statistical_days: 'จำนวนวันที่ใช้ในการสถิติ',
        organization_name_full: 'ชื่อองค์กร (ค้นหาทั้งหมด)',
        num_of_received_documents_r: 'จำนวนเอกสารที่ได้รับ (ฝ่ายรับผิดชอบ)',
        num_of_received_documents_nr: 'จำนวนเอกสารที่ได้รับ (ฝ่ายไม่รับผิดชอบ)',
        num_of_forwarded_documents_r: 'จำนวนเอกสารที่ส่งต่อ (ฝ่ายรับผิดชอบ)',
        num_of_forwarded_documents_nr: 'จำนวนเอกสารที่ส่งต่อ (ฝ่ายไม่รับผิดชอบ)',
        inquire_quantity_documents: 'จำนวนเอกสารที่สอบถาม',
    },
    // 乌克兰语
    ukUA: {
        query_time: 'Час запиту',
        number_of_closedCases: 'Кількість закритих випадків',
        percentage_of_closedCases: 'Відсоток закритих випадків',
        SAP: 'SAP',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        total_number_of_cases: 'Загальна кількість випадків',
        statistical_days: 'Статистичні дні',
        organization_name_full: 'Назва організації (повний запит)',
        num_of_received_documents_r: 'Кількість отриманих документів (відповідальна сторона)',
        num_of_received_documents_nr: 'Кількість отриманих документів (невідповідальна сторона)',
        num_of_forwarded_documents_r: 'Кількість пересланих документів (відповідальна сторона)',
        num_of_forwarded_documents_nr: 'Кількість пересланих документів (невідповідальна сторона)',
        inquire_quantity_documents: 'Кількість запитаних документів',
    },
    // 希腊语
    elGR: {
        query_time: 'Χρόνος ερωτήματος',
        number_of_closedCases: 'Αριθμός κλεισμένων περιστατικών',
        percentage_of_closedCases: 'Ποσοστό κλεισμένων περιστατικών',
        SAP: 'SAP',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        total_number_of_cases: 'Συνολικός αριθμός περιστατικών',
        statistical_days: 'Ημέρες στατιστικής',
        organization_name_full: 'Όνομα οργανισμού (πλήρης αναζήτηση)',
        num_of_received_documents_r: 'Αριθμός ληφθέντων εγγράφων (υπεύθυνο μέρος)',
        num_of_received_documents_nr: 'Αριθμός ληφθέντων εγγράφων (μη υπεύθυνο μέρος)',
        num_of_forwarded_documents_r: 'Αριθμός προωθηθέντων εγγράφων (υπεύθυνο μέρος)',
        num_of_forwarded_documents_nr: 'Αριθμός προωθηθέντων εγγράφων (μη υπεύθυνο μέρος)',
        inquire_quantity_documents: 'Ποσότητα εγγράφων προς ερώτηση',
    },
    // 爱沙尼亚
    etEE: {
        query_time: 'Päringu aeg',
        number_of_closedCases: 'Suletud juhtumite arv',
        percentage_of_closedCases: 'Suletud juhtumite protsent',
        SAP: 'SAP',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        total_number_of_cases: 'Juhtumite koguarv',
        statistical_days: 'Statistikapäevad',
        organization_name_full: 'Organisatsiooni nimi (täielik päring)',
        num_of_received_documents_r: 'Vastuvõetud dokumentide arv (vastutav pool)',
        num_of_received_documents_nr: 'Vastuvõetud dokumentide arv (mittevastutav pool)',
        num_of_forwarded_documents_r: 'Edastatud dokumentide arv (vastutav pool)',
        num_of_forwarded_documents_nr: 'Edastatud dokumentide arv (mittevastutav pool)',
        inquire_quantity_documents: 'Päritud dokumentide arv',
    },
    // 哈萨克
    kkKZ: {
        query_time: 'Сұрау уақыты',
        number_of_closedCases: 'Жабылған істер саны',
        percentage_of_closedCases: 'Жабылған істер пайызы',
        SAP: 'SAP',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        total_number_of_cases: 'Жағдайлардың жалпы саны',
        statistical_days: 'Статистикалық күндер',
        organization_name_full: 'Ұйым атауы (толық сұрау)',
        num_of_received_documents_r: 'Қабылданған құжаттар саны (жауапты тарап)',
        num_of_received_documents_nr: 'Қабылданған құжаттар саны (жауапсыз тарап)',
        num_of_forwarded_documents_r: 'Жіберілген құжаттар саны (жауапты тарап)',
        num_of_forwarded_documents_nr: 'Жіберілген құжаттар саны (жауапсыз тарап)',
        inquire_quantity_documents: 'Сұралған құжаттар саны',
    },
    // 希伯来语
    heIL: {
        query_time: 'זמן השאילתה',
        number_of_closedCases: 'מספר מקרים סגורים',
        percentage_of_closedCases: 'אחוז מקרים סגורים',
        SAP: 'SAP',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        total_number_of_cases: 'סך כל המקרים',
        statistical_days: 'ימי סטטיסטיקה',
        organization_name_full: 'שם הארגון (שאילתה מלאה)',
        num_of_received_documents_r: 'כמות מסמכים שהתקבלו (צד אחראי)',
        num_of_received_documents_nr: 'כמות מסמכים שהתקבלו (צד לא אחראי)',
        num_of_forwarded_documents_r: 'כמות מסמכים שהועברו (צד אחראי)',
        num_of_forwarded_documents_nr: 'כמות מסמכים שהועברו (צד לא אחראי)',
        inquire_quantity_documents: 'כמות מסמכים שנשאלו',
    },
};
